import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const Btn = styled.a`
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  top: ${(2166 / 2391) * 100}%;
  left: ${(60 / 710) * 100}%;
  right: ${(60 / 710) * 100}%;
  bottom: ${(100 / 2391) * 100}%;
`;
